import { createBrowserRouter } from "react-router-dom";
import { PATH } from "./path";
import { MainPage } from "../pages/mainPage/MainPage";
import { ErrorPage } from "../pages/errorPage/ErrorPage";
import { CataloguesPage } from "../pages/cataloguesPage/cataloguesPage";
import { Page404 } from "../pages/page404/Page404";
import { ReportsPage } from "../pages/reportsPage/reportsPage";
import { lazy, Suspense } from "react";
import UpdateContract from "../features/catalogues/lib/contracts/updateContract/updateContract";
import UpdateFlight from "../features/catalogues/lib/flight/updateFlight/updateFlight";


const AirStaffTable = lazy(
  () => import("../features/catalogues/lib/airStaff/airStaffTable")
);
const ContractsTable = lazy(
  () => import("../features/catalogues/lib/contracts/contractsTable")
);
const AirBaseTable = lazy(
  () => import("../features/catalogues/lib/airBase/airBaseTable")
);
const ContractorsTable = lazy(
  () => import("../features/catalogues/lib/contractors/contractorsTable")
);
const AirTransportTable = lazy(
  () => import("../features/catalogues/lib/airTransport/airTransportTable")
);
const WorkTypesTable = lazy(
  () => import("../features/catalogues/lib/workTypes/workTypesTable")
);
const FlightTable = lazy(
  () => import("../features/catalogues/lib/flight/flightTable")
)

export const router = createBrowserRouter([
  {
    path: PATH.MAIN,
    element: <MainPage />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: PATH.CATALOGUES,
        element: (
          <Suspense fallback={<h1>Обновление данных...</h1>}>
            <CataloguesPage />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
        children: [
          {
            path: PATH.CATALOGUES_STAFF,
            element: <AirStaffTable />,
            errorElement: <ErrorPage />,
            loader: async () => {
              await import("../features/catalogues/lib/airStaff/airStaffTable");
              return null;
            },
          },
          {
            path: PATH.CATALOGUES_BASES,
            element: <AirBaseTable />,
            errorElement: <ErrorPage />,
            loader: async () => {
              await import("../features/catalogues/lib/airBase/airBaseTable");
              return null;
            },
          },
          {
            path: PATH.CATALOGUES_TRANSPORT,
            element: <AirTransportTable />,
            errorElement: <ErrorPage />,
            loader: async () => {
              await import(
                "../features/catalogues/lib/airTransport/airTransportTable"
              );
              return null;
            },
          },
          {
            path: PATH.CATALOGUES_CONTRACTORS,
            element: <ContractorsTable />,
            errorElement: <ErrorPage />,
            loader: async () => {
              await import(
                "../features/catalogues/lib/contractors/contractorsTable"
              );
              return null;
            },
          },
          {
            path: PATH.CATALOGUES_CONTRACTS,
            element: <ContractsTable />,
            errorElement: <ErrorPage />,
            loader: async () => {
              await import(
                "../features/catalogues/lib/contracts/contractsTable"
              );
              return null;
            },
          },
          {
            path: `${PATH.CATALOGUES_CONTRACTS}/edit/:id`,
            element: <UpdateContract />,
            errorElement: <ErrorPage />,
          },
          {
            path: PATH.CATALOGUES_WORKS,
            element: <WorkTypesTable />,
            errorElement: <ErrorPage />,
            loader: async () => {
              await import("../features/catalogues/lib/workTypes/workTypesTable");
              return null;
            },
          },
          {
            path: PATH.FLYGHTS,
            element: <FlightTable />,
            errorElement: <ErrorPage />,
            loader: async () => {
              await import("../features/catalogues/lib/flight/flightTable");
              return null;
            },
          },
          {
            path: `${PATH.FLYGHTS}/edit/:id`,
            element: <UpdateFlight />,
            errorElement: <ErrorPage />,
          },
        ],
      },
      {
        path: PATH.REPORTS,
        element: <ReportsPage />,
        errorElement: <ErrorPage />,
      },
    ],
  },
  {
    path: PATH.NOT_FOUND,
    element: <Page404 />,
  },
]);
